const isBrowser = typeof window !== 'undefined'

const getScreenSize = () => {
  const width = isBrowser ? window.innerWidth : 0
  if (width < 544) {
    return 'xs'
  } if (width >= 544 && width < 768) {
    return 'sm'
  } if (width >= 768 && width < 992) {
    return 'md'
  } if (width >= 992 && width < 1200) {
    return 'lg'
  }
  return 'xl'
}

export default getScreenSize
